import React from 'react';
import { localize } from '/react4xp/mixins/helpers';
import PrintForm2 from '/react4xp/mixins/ui/print-form-2';

export const columns = (translations: Record<string, any>, token: any, printUrl: string) => [
    {
        title: localize('data', translations),
        dataIndex: 'receiveDate',
        render: (a) => a.slice(0, 10),
    },
    {
        title: localize('title', translations),
        render: () => localize('fno-nz001-page-title', translations),
    },
    {
        title: localize('detailed-information', translations),
        render: (_, row) => {
            return (
                <PrintForm2
                    tokenStr={token}
                    tableModal
                    params={{ incomingNumber: row.incomingNumber }}
                    apiUrl={printUrl}
                    translations={translations}
                />
            );
        },
    },
];
